/**
 *
 * API Keys
 *
 */

import React, { memo } from 'react';

import { Card } from 'components/DataDisplay';
import { useInjector } from 'utils/inject';

import { ApiKeysTable } from './components/ApiKeysTable';
import { apiKeysSaga } from './saga';
import { reducer, sliceKey } from './slice';

export const ApiKeys = memo(() => {
  useInjector(sliceKey, reducer, apiKeysSaga);

  return (
    <Card>
      <ApiKeysTable />
    </Card>
  );
});
